import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class Cards1 extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false,
      feedback_title: ``,
      feedback_name: ``,
      // Изменяем структуру: теперь массив объектов lightbox для каждой карточки
      lightboxControllers: [],
      lightboxSources: []
    }
  }

  componentDidMount() {
    // Инициализируем контроллеры lightbox для каждой карточки
    const { list } = this.props;
    const lightboxControllers = list.map(() => ({
      toggler: false,
      slide: 1
    }));
    
    // Собираем все источники для каждой карточки
    const lightboxSources = list.map(item => {
      if (item.galary && Array.isArray(item.galary)) {
        // Используем galary, если он есть
        return item.galary.map(galItem => galItem.image);
      } else if (item.image || item.fon) {
        // Или используем одиночное изображение
        return [item.image || item.fon];
      } else if (item.full) {
        // Или full изображение
        return [item.full];
      }
      return [];
    });

    this.setState({
      lightboxControllers,
      lightboxSources
    });
  }

  componentDidUpdate(prevProps) {
    // Обновляем state при изменении списка
    if (prevProps.list !== this.props.list) {
      const lightboxControllers = this.props.list.map(() => ({
        toggler: false,
        slide: 1
      }));
      
      const lightboxSources = this.props.list.map(item => {
        if (item.galary && Array.isArray(item.galary)) {
          return item.galary.map(galItem => galItem.image);
        } else if (item.image || item.fon) {
          return [item.image || item.fon];
        } else if (item.full) {
          return [item.full];
        }
        return [];
      });

      this.setState({
        lightboxControllers,
        lightboxSources
      });
    }
  }

  showFeedback = ( title, name ) => {
    this.setState({ show_feedback: true, feedback_title: title, feedback_name: name });
  }
  
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  openLightbox = (cardIndex, imageIndex = 0) => {
    const { list } = this.props;
    const { lightboxControllers } = this.state;
    
    // Создаем новый массив контроллеров с обновленным состоянием для конкретной карточки
    const updatedControllers = [...lightboxControllers];
    updatedControllers[cardIndex] = {
      toggler: !updatedControllers[cardIndex]?.toggler,
      slide: imageIndex + 1 // +1 потому что в fslightbox слайды начинаются с 1
    };

    this.setState({
      lightboxControllers: updatedControllers
    });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  getImageSources = (cardIndex) => {
    const { list } = this.props;
    const item = list[cardIndex];
    
    if (item.galary && Array.isArray(item.galary)) {
      // Возвращаем массив изображений из галереи
      return item.galary.map(galItem => galItem.image);
    } else if (item.image || item.fon) {
      // Или одиночное изображение
      return [item.image || item.fon];
    } else if (item.full) {
      return [item.full];
    }
    
    return [];
  }

  render() {
    const { list, title, text, rtext, margin, cols, bg, imageSize, button } = this.props,
    { show_feedback, feedback_title, feedback_name, lightboxControllers, lightboxSources } = this.state

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
              className={styles.title}
            />
          }

          <div className={`${styles.list} ${styles[`grid-${cols}`]}`}>
            {list.map((elm, k) => {
              // Получаем источники изображений для текущей карточки
              const currentSources = this.getImageSources(k);
              // Получаем контроллер для текущей карточки
              const currentController = lightboxControllers[k] || { toggler: false, slide: 1 };
              
              return (
                <React.Fragment key={k}>
                  {/* Lightbox компонент для каждой карточки */}
                  <ClientOnlyFsLightbox
                    toggler={currentController.toggler}
                    sources={currentSources}
                    slide={currentController.slide}
                  />
                  
                  <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
                    {/* Основное изображение карточки */}
                    {elm?.image &&
                      <Image 
                        className={styles.b_topimg} 
                        src={elm?.image} 
                        width={imageSize?.width} 
                        height={imageSize?.height} 
                        alt={elm?.name}
                        // При клике открываем lightbox на первом изображении
                        onClick={() => this.openLightbox(k, 0)}
                        style={{cursor: currentSources.length > 0 ? 'pointer' : 'default'}}
                      />
                    }
                    
                    {elm?.icon &&
                      <div className={styles.b_icon}>
                        <Image src={elm?.icon} width={21} height={21} alt={`и-${k}`} />
                      </div>
                    }
                    <div className={styles.b_title}>
                      <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  </div>
                </React.Fragment>
              )
            })}
          </div>
        </Container>
        <FeedbackForm
          title={feedback_title}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[
            {
              name: `Элемент`,
              value: feedback_name
            }
          ]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

Cards1.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  text: PropTypes.string,
  rtext: PropTypes.string,
  margin: PropTypes.string,
  cols: PropTypes.string,
  bg: PropTypes.string,
  imageSize: PropTypes.object,
  button: PropTypes.object
}

Cards1.defaultProps = {
  list: [],
  title: ``,
  text: ``,
  rtext: ``,
  margin: `none`,
  cols: `3`,
  bg: `1`,
  imageSize: {
    width: 346,
    height: 202
  },
  button: {
    text: ``,
    width: 0,
    action: () => {}
  }
}

export default Cards1